module.exports = __webpack_public_path__ + "assets/img/image-55-1280.3b8ed37b.webp";